import { LAYOUT_TYPE_CLASSIC, LAYOUT_TYPE_PINBOARD } from '../constants/layout-types';
import { CARD_SIZE_SMALL, CARD_SIZE_MEDIUM, CARD_SIZE_LARGE } from '../constants/card-sizes';

export default function getLayoutName(layoutType = LAYOUT_TYPE_PINBOARD, cardSize = CARD_SIZE_MEDIUM) {
  if (layoutType === LAYOUT_TYPE_CLASSIC) {
    return 'classic';
  }

  switch (cardSize) {
    case CARD_SIZE_SMALL:
      return 'small';
    case CARD_SIZE_MEDIUM:
      return 'medium';
    case CARD_SIZE_LARGE:
      return 'large';
    default:
      return 'small';
  }
}



// WEBPACK FOOTER //
// ./app/services/get-layout-name.js